/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.getSuggestionsSkeleton'

export { $nsid }

/** Get a skeleton of suggested actors. Intended to be called and then hydrated through app.bsky.actor.getSuggestions */
const main = l.query(
  $nsid,
  l.params({
    viewer: l.optional(l.string({ format: 'did' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
    relativeToDid: l.optional(l.string({ format: 'did' })),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    actors: l.array(
      l.ref<UnspeccedDefs.SkeletonSearchActor>(
        (() => UnspeccedDefs.skeletonSearchActor) as any,
      ),
    ),
    relativeToDid: l.optional(l.string({ format: 'did' })),
    recId: l.optional(l.integer()),
    recIdStr: l.optional(l.string()),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
